import type { Schema } from '@/shared/api/contract';

/** Straight from the contract: cubas.domain.schemas.email. The rest is in the inbox. */
export type Email = Schema<'EmailRead'>;
export type EmailDetail = Schema<'EmailDetail'>;
export type TriageDecision = Schema<'TriageDecisionRead'>;
export type TriageCorrection = Schema<'TriageCorrection'>;

/** The `mailbox` of a document uploaded by hand from a quote (contract v8). */
export const MANUAL_MAILBOX = 'manual';

/**
 * A mailbox name as the screen says it. Real mailboxes are addresses and read fine as
 * they are; the one that is not a mailbox gets words instead of a token.
 */
export function mailboxLabel(mailbox: string): string {
  return mailbox === MANUAL_MAILBOX ? 'Subidos a mano' : mailbox;
}
